export const normalizeAppointmentPassId = (id) => {
  if (id === null || id === undefined || id === "") {
    return null
  }

  const numericId = Number(id)
  return Number.isNaN(numericId) ? id : numericId
}

export const hasAppointmentPassById = (passes, id) => {
  const normalizedId = normalizeAppointmentPassId(id)
  if (normalizedId == null) {
    return false
  }

  return passes.has(normalizedId) || passes.has(String(normalizedId))
}

export const setAppointmentPassById = (passes, pass) => {
  const normalizedId = normalizeAppointmentPassId(pass?.id)
  if (normalizedId == null) {
    return false
  }

  passes.delete(String(normalizedId))
  pass.id = normalizedId
  passes.set(normalizedId, pass)
  return true
}

export const deleteAppointmentPassById = (passes, id) => {
  const normalizedId = normalizeAppointmentPassId(id)
  if (normalizedId == null) {
    return false
  }

  const deleted = passes.delete(normalizedId)
  return passes.delete(String(normalizedId)) || deleted
}
